module.exports = __webpack_public_path__ + "static/foundry-vtt-02b0d21c38d69ba54ebad60d0f97e9f9.png";